import { apiClient } from '@shared/utils/api-client';
import { authUtils } from '@shared/utils/axios-instance';

export interface LoginDto {
  email: string;
  password: string;
}

export interface LoginResponse {
  access_token: string;
  admin: {
    id: number;
    email: string;
    name: string | null;
  };
}

export interface LogoutResponse {
  message: string;
}

export interface PhoneVerifyResponse {
  access_token: string;
  refresh_token: string;
  user: {
    id: number;
    phone: string;
    name: string | null;
  };
}

export type EmailVerifyResponse = PhoneVerifyResponse;

export interface BindLoginCredentialResponse {
  message: string;
  user: {
    id: number;
    phone: string | null;
    email: string | null;
    name: string | null;
    surname: string | null;
  };
}

export const authApi = {
  login: async (data: LoginDto): Promise<LoginResponse> => {
    return apiClient.post<LoginResponse>('/auth/login', data);
  },

  sendPhoneCode: async (phone: string): Promise<{ message?: string }> => {
    return apiClient.post('/auth/phone/send-code', { phone });
  },

  verifyPhone: async (
    phone: string,
    code: string,
    advertisingConsent = false,
  ): Promise<PhoneVerifyResponse> => {
    return apiClient.post<PhoneVerifyResponse>('/auth/phone/verify', {
      phone,
      code,
      advertisingConsent,
    });
  },

  sendEmailCode: async (email: string): Promise<{ message?: string }> => {
    return apiClient.post('/auth/email/send-code', { email });
  },

  verifyEmail: async (
    email: string,
    code: string,
    advertisingConsent = false,
  ): Promise<EmailVerifyResponse> => {
    return apiClient.post<EmailVerifyResponse>('/auth/email/verify', {
      email,
      code,
      advertisingConsent,
    });
  },

  sendBindPhoneCode: async (phone: string): Promise<{ message?: string }> => {
    return apiClient.post('/auth/user/login-phone/send-code', { phone });
  },

  verifyBindPhone: async (
    phone: string,
    code: string,
  ): Promise<BindLoginCredentialResponse> => {
    return apiClient.post('/auth/user/login-phone/verify', { phone, code });
  },

  sendBindEmailCode: async (email: string): Promise<{ message?: string }> => {
    return apiClient.post('/auth/user/login-email/send-code', { email });
  },

  verifyBindEmail: async (
    email: string,
    code: string,
  ): Promise<BindLoginCredentialResponse> => {
    return apiClient.post('/auth/user/login-email/verify', { email, code });
  },

  logout: async (): Promise<LogoutResponse> => {
    // Передаём refresh этого устройства — иначе бэк снесёт все сессии аккаунта
    const refresh_token = authUtils.getRefreshToken();
    return apiClient.post<LogoutResponse>(
      '/auth/logout',
      refresh_token ? { refresh_token } : {},
    );
  },
};
